import { createAction } from '@reduxjs/toolkit';

// What the API layer reports about the session. The session and nav slices react to these,
// so the API layer does not import them (shared code must not depend on entities).

// The refresh token is missing or was rejected: the user is signed out
export const sessionExpired = createAction('session/expired');

// The backend rotated the token pair
export const tokensRefreshed = createAction<{
  accessToken: string;
  refreshToken: string;
}>('session/tokensRefreshed');

// The backend ended the session (e.g. a sign-in elsewhere); the message is shown on the login page
export const sessionEnded = createAction<string>('session/ended');

// The only part of the backend's answer that tells a session replaced by a sign in elsewhere
// apart from an expired token (a blocked account or a sign out answer with their own codes).
// Not translated by the backend, so the check works in every language.
export const SIGNED_IN_ELSEWHERE_TEXT = 'another location';
